
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { domainByCountry } from '~/assets/ts/Domains'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  props: ['showText'],
  setup() {
    const {
      app: { i18n },
    } = useContext()

    const currentCountryCode: string = getCountryCode()
    const showCountryList = ref(false as boolean)

    const countryList: { code: string; url: string; text: string }[] = []
    const countries: string[] = [
      'at',
      'beFr',
      'beNl',
      'ch',
      'cz',
      'fr',
      'de',
      'dk',
      'ee',
      'es',
      'hk',
      'jp',
      'kr',
      'nl',
      'no',
      'sg',
      'tw',
      'us',
    ]

    for (const countryIdx in countries) {
      countryList.push({
        code: countries[countryIdx],
        url: domainByCountry(countries[countryIdx]),
        text: i18n
          .t('elements.discoverTheWorld.country.' + countries[countryIdx])
          .toString(),
      })
    }

    countryList.sort((a, b) => (a.text > b.text ? 1 : -1))

    return { countryList, currentCountryCode, showCountryList }
  },
})
